import { call, put, select, takeLatest } from 'redux-saga/effects'
import { setViewCampaignSelected } from '../../containers/CreateCampaigns/createCampaignReducer';
import { getProductSegment, } from '../../containers/CreateCampaigns/createCampaignReducer';
import { getCampaignSummaryApi } from '../../network/requests';
import { hideLoader, showLoader } from '../Loader/loaderReducer';
import { getSummaryError, setSummary } from './campaignSummaryReducer';
import { showNavHeadersAction } from '../NavBar/navBarReducer';


function* getSummary(action) {
    console.log(action.payload);
    try {
        yield put(showLoader());
        const response = yield call(getCampaignSummaryApi, action.payload);
        const campaignSummary = { ...response }
        yield put(setViewCampaignSelected(campaignSummary))
        yield put(setSummary(campaignSummary));
        yield put(hideLoader());
        yield put(showNavHeadersAction());
    } catch (e) {
        console.log('err', e);
        yield put(getSummaryError(e));
        yield put(hideLoader());
    }
}



function* campaignSummarySaga() {
    yield takeLatest('CampaignSummary/getSummary', getSummary)
    
}

export default campaignSummarySaga;